import React, { useState, useEffect } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import Dashboard from './Components/Dashboard';
import CustomLogin from './Components/CustomLogin';
import QuickSightDashboard from './Components/QuickSightPage';
import DynamicPool from './Components/DynamicPool';

const App = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [checkingAuth, setCheckingAuth] = useState(true);

  const checkAuthStatus = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      if (user) {
        console.log('User is authenticated:', user);
        setAuthenticated(true);
        localStorage.setItem('authenticated', 'true');
      } else {
        handleLogout();
      }
    } catch (error) {
      console.error('Error fetching current user:', error);
      handleLogout();
    } finally {
      setCheckingAuth(false);
    }
  };

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const handleLogin = async (token) => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      console.log('User logged in:', user);
      setAuthenticated(true);
      localStorage.setItem('authenticated', 'true');
      localStorage.setItem('idToken', token);
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  const handleLogout = () => {
    Auth.signOut()
      .then(() => {
        setAuthenticated(false);
        localStorage.removeItem('authenticated');
        localStorage.removeItem('idToken');
      })
      .catch((error) => console.error('Logout error:', error));
  };

  if (checkingAuth) {
    return <div></div>; // Add a loader here for better UX
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route
            exact
            path="/"
            render={(props) =>
              authenticated ? (
                <Redirect to="/dashboard" />
              ) : (
                <CustomLogin {...props} onLogin={handleLogin} />
              )
            }
          />
          <Route
            exact
            path="/dashboard"
            render={(props) =>
              authenticated ? (
                <Dashboard {...props} onLogout={handleLogout} />
              ) : (
                <Redirect to="/" />
              )
            }
          />
          <Route
            exact
            path="/analytics"
            render={(props) =>
              authenticated ? (
                <QuickSightDashboard {...props} />
              ) : (
                <Redirect to="/" />
              )
            }
          />
          <Route
            exact
            path="/dynamic-pool/:poolName"
            render={(props) =>
              authenticated ? (
                <DynamicPool {...props} />
              ) : (
                <Redirect to="/" />
              )
            }
          />
        </Switch>
      </BrowserRouter>
    </div>
  );
};

export default App;
